/* =========================================================
   ARCHERS CLUB — Atelier draft
   ========================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- light / dark toggle ---------- */
  var docEl = document.documentElement;
  requestAnimationFrame(function () { docEl.classList.add("theme-ready"); });

  function currentTheme() {
    return docEl.getAttribute("data-theme") === "dark" ? "dark" : "light";
  }

  function applyTheme(mode) {
    if (mode === "dark") docEl.setAttribute("data-theme", "dark");
    else docEl.removeAttribute("data-theme");
    try { localStorage.setItem('ac-theme', mode); } catch (e) {}
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', mode === 'dark' ? '#0e0c0b' : '#f7f4ef');
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
    });
  }

  applyTheme(currentTheme());

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-theme-toggle]')) return;
    applyTheme(currentTheme() === 'dark' ? 'light' : 'dark');
  });

  /* ---------- sticky buy bar ---------- */
  var stickyBar = document.querySelector('[data-sticky-bar]');
  var buyAnchor = document.querySelector('[data-buy-anchor]');

  if (stickyBar && buyAnchor && 'IntersectionObserver' in window) {
    var barIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    barIO.observe(buyAnchor);

    stickyBar.querySelectorAll('[data-sticky-submit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var realBtn = document.querySelector('[data-add-button]');
        if (realBtn) realBtn.click();
      });
    });
    stickyBar.querySelectorAll('[data-sticky-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var realBtn = document.querySelector('[data-buy-now]');
        if (realBtn) realBtn.click();
      });
    });
  }

  /* ---------- gallery lightbox ---------- */
  var lightbox = document.querySelector('[data-lightbox]');

  if (lightbox) {
    var lbImg = lightbox.querySelector('img');

    function openLightbox(src, alt) {
      if (!lbImg) return;
      lbImg.setAttribute('src', src);
      lbImg.setAttribute('alt', alt || '');
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    }

    document.addEventListener('click', function (e) {
      var zoom = e.target.closest('[data-zoom]');
      if (zoom) {
        var img = zoom.querySelector('img') || zoom;
        openLightbox(img.getAttribute('src'), img.getAttribute('alt'));
        return;
      }
      if (e.target.closest('[data-lightbox-close]') || e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  /* ---------- header height var + solid state ---------- */
  var header = document.querySelector('.header');

  function setHeaderH() {
    if (!header) return;
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }

  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-solid', window.scrollY > 40);
  }

  setHeaderH();
  onScroll();
  window.addEventListener('resize', setHeaderH);
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- mobile drawer ---------- */
  var drawer = document.getElementById('drawer');

  function toggleDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.classList.toggle('no-scroll', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { toggleDrawer(true); }
    else if (e.target.closest('[data-drawer-close]')) { toggleDrawer(false); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') toggleDrawer(false);
  });

  /* ---------- scroll reveal ---------- */
  var revealables = document.querySelectorAll('[data-reveal]');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealables.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealables.forEach(function (el) { io.observe(el); });
  }

  /* Theme editor re-renders a section when blocks are added or edited; the
     fresh markup was never observed, so it would stay invisible. Show it. */
  ['shopify:section:load', 'shopify:block:select'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var scope = e.target && e.target.querySelectorAll ? e.target : document;
      scope.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
      if (scope.matches && scope.matches('[data-reveal]')) scope.classList.add('is-in');
    });
  });

  /* ---------- carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var viewport = root.querySelector('[data-carousel-viewport]');
    if (!viewport) return;

    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    var slides = Array.prototype.slice.call(viewport.children);

    function step() {
      var first = slides[0];
      if (!first) return viewport.clientWidth;
      var gap = parseFloat(getComputedStyle(viewport).columnGap || getComputedStyle(viewport).gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return viewport.scrollWidth - viewport.clientWidth;
    }

    function sync() {
      var x = viewport.scrollLeft;
      var max = maxScroll();
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;

      if (dotsWrap) {
        var idx = Math.round(x / step());
        Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
          dot.classList.toggle('is-active', i === idx);
          dot.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
      }
    }

    if (prev) prev.addEventListener('click', function () { viewport.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { viewport.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });

    if (dotsWrap && slides.length > 1) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () {
          viewport.scrollTo({ left: step() * i, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
        dotsWrap.appendChild(b);
      });
    }

    var raf;
    viewport.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();

    /* keep PDP thumbs in step with the stage carousel */
    if (root.hasAttribute('data-gallery')) {
      var thumbs = document.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          viewport.scrollTo({ left: step() * i, behavior: reduceMotion ? 'auto' : 'smooth' });
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });
      viewport.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var idx = Math.round(viewport.scrollLeft / step());
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
          sync();
        });
      }, { passive: true });
    }
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.closest('.qty') && btn.closest('.qty').querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + (btn.getAttribute('data-qty') === 'up' ? 1 : -1);
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var key = form.getAttribute('data-product-form');
    var dataEl = document.querySelector('[data-variants-for="' + key + '"]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEls = document.querySelectorAll('[data-price-for="' + key + '"], [data-price-for="' + key + '-bar"]');
    var saveEl = document.querySelector('[data-save-for="' + key + '"]');
    var submit = form.querySelector('[data-add-button]');
    var moneyFormat = dataEl.getAttribute('data-money-format') || '{{amount}}';

    function money(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/[.,]00(?!\d)/, '');
    }

    function chosen() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (group) {
        var c = group.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function find(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      })[0];
    }

    function refresh(initial) {
      var opts = chosen();
      var variant = find(opts);

      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        var label = group.querySelector('[data-option-current]');
        if (label) label.textContent = opts[index] || '';
        group.querySelectorAll('input').forEach(function (input) {
          var probe = opts.slice();
          probe[index] = input.value;
          var candidate = find(probe);
          input.disabled = !candidate || !candidate.available;
        });
      });

      var buyNow = form.querySelector('[data-buy-now]');
      var stickyBuy = document.querySelector('[data-sticky-buy]');

      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = submit.getAttribute('data-unavailable') || 'Unavailable'; }
        if (buyNow) buyNow.disabled = true;
        if (stickyBuy) stickyBuy.disabled = true;
        return;
      }
      if (buyNow) buyNow.disabled = !variant.available;
      if (stickyBuy) stickyBuy.disabled = !variant.available;

      if (idInput) idInput.value = variant.id;

      if (priceEls.length) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="price--was">' + money(variant.compare_at_price) + '</span>';
        }
        html += money(variant.price);
        priceEls.forEach(function (el) { el.innerHTML = html; });
      }

      if (saveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          saveEl.textContent = 'Save ' + pct + '% — ' + money(variant.compare_at_price - variant.price) + ' off';
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? (submit.getAttribute('data-add') || 'Add to bag')
          : (submit.getAttribute('data-soldout') || 'Sold out');
      }

      /* jump to the variant's photo only when the shopper picks a colour -
         on first load the gallery must open on image 1 (lead images) */
      if (!initial && variant.featured_image && variant.featured_image.src) {
        var slide = document.querySelector('[data-variant-image="' + variant.featured_image.id + '"]');
        var vp = document.querySelector('[data-gallery] [data-carousel-viewport]');
        if (slide && vp) {
          vp.scrollTo({ left: slide.offsetLeft - vp.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index] input')) refresh();
    });

    refresh(true);
  });
})();

/* =========================================================
   V4 — cart drawer, predictive search, scroll-driven motion
   ========================================================= */
(function () {
  'use strict';

  var AC = window.AC || { routes: {} };
  var R = AC.routes || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var fmt = AC.moneyFormat || '{{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    }).replace(/[.,]00(?!\d)/, '');
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function lockScroll(on) { document.body.classList.toggle('no-scroll', on); }

  /* =======================================================
     CART DRAWER
     ======================================================= */
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocus = null;

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var label = drawer.querySelector('[data-cart-count-label]');
    if (label) label.textContent = '(' + cart.item_count + ')';
    var sub = drawer.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    var foot = drawer.querySelector('[data-cart-foot]');
    if (foot) foot.hidden = cart.item_count === 0;

    var body = drawer.querySelector('[data-cart-items]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cartdrawer__empty"><p>Your bag is empty.</p>' +
        '<a class="btn btn--ghost" href="/collections/all">Start shopping</a></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (item, i) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var img = item.image
        ? '<img src="' + esc(sized(item.image, 200)) + '" alt="" width="78" height="78" loading="lazy">'
        : '<span class="citem__ph"></span>';
      var was = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
      return '<div class="citem" style="animation-delay:' + (i * 60) + 'ms">' +
        '<a href="' + esc(item.url) + '">' + img + '</a>' +
        '<div><a class="citem__t" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (variant ? '<span class="citem__v">' + esc(variant) + '</span>' : '') +
          '<div class="qty">' +
            '<button type="button" data-qty="down" aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" min="0" value="' + item.quantity + '" data-line-key="' + esc(item.key) + '" aria-label="Quantity">' +
            '<button type="button" data-qty="up" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="citem__rm" type="button" data-line-remove="' + esc(item.key) + '">Remove</button>' +
        '</div>' +
        '<div class="citem__p">' + was + money(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function openCart() {
    if (!drawer) { window.location.href = R.cart || '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open', 'is-busy');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var panel = drawer.querySelector('.cartdrawer__panel');
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    return fetchCart().then(function (cart) { renderCart(cart); }).finally(function () { drawer.classList.remove('is-busy'); });
  }

  function closeCart() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function changeLine(key, qty) {
    if (!drawer) return;
    drawer.classList.add('is-busy');
    fetch((R.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.items) { renderCart(cart); return; }
        /* rejected (e.g. not enough stock): show why, then re-sync the real cart */
        return fetchCart().then(function (real) {
          renderCart(real);
          var body = drawer.querySelector('[data-cart-items]');
          if (body && cart && (cart.description || cart.message)) {
            var note = document.createElement('p');
            note.className = 'notice notice--err cartdrawer__msg';
            note.setAttribute('role', 'alert');
            note.textContent = cart.description || cart.message;
            body.insertBefore(note, body.firstChild);
          }
        });
      })
      .finally(function () { drawer.classList.remove('is-busy'); });
  }

  function addToCart(payload, isForm) {
    return fetch((R.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
                      : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm ? payload : JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
        return data;
      });
    });
  }

  if (drawer) {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && !document.body.classList.contains('template-cart')) {
        e.preventDefault();
        var mobileMenu = document.getElementById('drawer');
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
          mobileMenu.classList.remove('is-open');
          mobileMenu.setAttribute('aria-hidden', 'true');
        }
        openCart();
        return;
      }
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      var rm = e.target.closest('[data-line-remove]');
      if (rm) changeLine(rm.getAttribute('data-line-remove'), 0);
    });

    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-key]');
      if (!input) return;
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      clearTimeout(input._t);
      input._t = setTimeout(function () { changeLine(input.getAttribute('data-line-key'), qty); }, 350);
    });

    /* product page form -> AJAX add, then open the drawer */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      /* which button submitted: Buy Now goes straight to checkout */
      var buying = !!(e.submitter && e.submitter.hasAttribute('data-buy-now'));
      var btn = buying ? e.submitter : form.querySelector('[data-add-button]');
      var err = form.querySelector('.pdp__error');
      if (err) err.remove();
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = buying ? 'Going to checkout…' : 'Adding…'; }
      addToCart(new FormData(form), true)
        .then(function () {
          if (buying) {
            window.location.href = (window.AC && AC.routes && AC.routes.checkout) || '/checkout';
            return new Promise(function () {}); /* keep the button busy while the page changes */
          }
          return openCart();
        })
        .catch(function (ex) {
          var p = document.createElement('p');
          p.className = 'pdp__error';
          p.setAttribute('role', 'alert');
          p.textContent = ex.message;
          form.appendChild(p);
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to bag'; }
        });
    });

    /* quick add on product cards */
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-quick-add]');
      if (!q) return;
      e.preventDefault();
      q.classList.add('is-loading');
      addToCart({ items: [{ id: parseInt(q.getAttribute('data-quick-add'), 10), quantity: 1 }] })
        .then(function () {
          q.classList.remove('is-loading');
          q.classList.add('is-done');
          var label = q.querySelector('span');
          if (label) label.textContent = 'Added';
          setTimeout(function () {
            q.classList.remove('is-done');
            if (label) label.textContent = 'Add';
          }, 2200);
          return openCart();
        })
        .catch(function () { q.classList.remove('is-loading'); var host = q.closest('.card, .wrec'); if (host && host.querySelector('a')) window.location.href = host.querySelector('a').href; });
    });
  }

  /* =======================================================
     PREDICTIVE SEARCH
     ======================================================= */
  var search = document.querySelector('[data-search]');

  if (search) {
    var sInput = search.querySelector('[data-search-input]');
    var sResults = search.querySelector('[data-search-results]');
    var sHint = sResults ? sResults.innerHTML : '';
    var sTimer, sCtrl;

    function openSearch() {
      search.classList.add('is-open');
      search.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      setTimeout(function () { if (sInput) sInput.focus(); }, 60);
    }
    function closeSearch() {
      if (!search.classList.contains('is-open')) return;
      search.classList.remove('is-open');
      search.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) {
        e.preventDefault();
        var mobileMenu = document.getElementById('drawer');
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
          mobileMenu.classList.remove('is-open');
          mobileMenu.setAttribute('aria-hidden', 'true');
        }
        openSearch();
      } else if (e.target.closest('[data-search-close]')) {
        closeSearch();
      }
    });

    function priceCents(p) {
      var v = p.price_min != null ? p.price_min : p.price;
      if (typeof v === 'number') return v;
      var f = parseFloat(v);
      return isNaN(f) ? 0 : Math.round(f * 100);
    }

    function runSearch(q) {
      if (sCtrl) sCtrl.abort();
      sCtrl = 'AbortController' in window ? new AbortController() : null;
      var url = (R.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: sCtrl ? sCtrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          if (!ps.length) {
            sResults.innerHTML = '<p class="search-overlay__hint">Nothing found for “' + esc(q) + '”.</p>';
            return;
          }
          sResults.innerHTML = '<div class="sres">' + ps.map(function (p, i) {
            var src = p.image || (p.featured_image && p.featured_image.url) || '';
            return '<a class="sres__item" style="animation-delay:' + (i * 50) + 'ms" href="' + esc(p.url) + '">' +
              (src ? '<img src="' + esc(sized(src, 360)) + '" alt="" loading="lazy">' : '<span class="sres__ph"></span>') +
              '<strong>' + esc(p.title) + '</strong><span>' + money(priceCents(p)) + '</span></a>';
          }).join('') + '</div>' +
          '<div class="sres__all"><a class="btn btn--ghost btn--block" href="' + esc((R.search || '/search') + '?type=product&q=' + encodeURIComponent(q)) + '">See all results</a></div>';
        })
        .catch(function (ex) { if (ex && ex.name === 'AbortError') return; });
    }

    if (sInput) {
      sInput.addEventListener('input', function () {
        var q = sInput.value.trim();
        clearTimeout(sTimer);
        if (q.length < 2) { sResults.innerHTML = sHint; return; }
        sTimer = setTimeout(function () { runSearch(q); }, 220);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* =======================================================
     FACETS — auto-submit sort + checkbox filters
     ======================================================= */
  document.querySelectorAll('[data-facets]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-autosubmit], input[type="checkbox"]')) form.submit();
    });
    /* only one dropdown open at a time */
    form.querySelectorAll('details.pill-dd').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        form.querySelectorAll('details.pill-dd[open]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.pill-dd')) form.querySelectorAll('details.pill-dd[open]').forEach(function (o) { o.open = false; });
    });
  });

  /* =======================================================
     DISPATCH DATE  (N days ahead; 1 = tomorrow.
     Sundays are skipped only if the section setting asks for it)
     ======================================================= */
  document.querySelectorAll('[data-eta]').forEach(function (el) {
    var days = parseInt(el.getAttribute('data-days'), 10) || 0;
    if (!days) return;
    var skipSunday = el.hasAttribute('data-skip-sunday');
    var d = new Date();
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!skipSunday || d.getDay() !== 0) added++;
    }
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    var isTomorrow = d.toDateString() === tomorrow.toDateString();
    var label = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    var span = el.querySelector('span');
    if (span) span.innerHTML = 'Order today &mdash; dispatched ' +
      (isTomorrow ? '<b>tomorrow, ' + esc(label) + '</b>' : 'by <b>' + esc(label) + '</b>');
  });

  /* =======================================================
     STATEMENT — split into words
     ======================================================= */
  var statements = [];
  document.querySelectorAll('[data-words]').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map(function (w) { return '<span class="w">' + esc(w) + '</span>'; }).join(' ');
    statements.push({ el: el, words: el.querySelectorAll('.w') });
    if (reduceMotion) el.querySelectorAll('.w').forEach(function (w) { w.classList.add('is-lit'); });
  });

  /* =======================================================
     SCROLL STORY
     ======================================================= */
  document.querySelectorAll('[data-story]').forEach(function (story) {
    var steps = story.querySelectorAll('[data-story-step]');
    var imgs = story.querySelectorAll('[data-story-img]');
    var num = story.querySelector('[data-story-num]');
    if (!('IntersectionObserver' in window) || !steps.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = entry.target.getAttribute('data-story-step');
        steps.forEach(function (s) { s.classList.toggle('is-active', s === entry.target); });
        imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-story-img') === idx); });
        if (num) num.textContent = ('0' + (parseInt(idx, 10) + 1)).slice(-2);
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    steps.forEach(function (s) { io.observe(s); });
  });

  /* =======================================================
     COUNTERS
     ======================================================= */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window && !reduceMotion) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cio.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count')) || 0;
        var start = null;
        var dur = 1500;
        function tick(t) {
          if (!start) start = t;
          var p = Math.min(1, (t - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString('en-US');
          if (p < 1) requestAnimationFrame(tick);
        }
        el.textContent = '0';
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  /* =======================================================
     POINTER EFFECTS — card tilt + magnetic buttons
     ======================================================= */
  if (finePointer && !reduceMotion) {
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('[data-tilt]');
      if (card) {
        var media = card.querySelector('.card__media');
        var r = (media || card).getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        if (x >= 0 && x <= 1 && y >= 0 && y <= 1) {
          card.style.setProperty('--ry', ((x - 0.5) * 7).toFixed(2) + 'deg');
          card.style.setProperty('--rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
          card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        }
      }
      var mag = e.target.closest && e.target.closest('[data-magnetic], .hero__cta .btn');
      if (mag && !mag.classList.contains('btn--block')) {
        var b = mag.getBoundingClientRect();
        var dx = e.clientX - (b.left + b.width / 2);
        var dy = e.clientY - (b.top + b.height / 2);
        mag.style.transform = 'translate(' + (dx * 0.22).toFixed(1) + 'px,' + (dy * 0.32).toFixed(1) + 'px)';
      }
    }, { passive: true });

    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('[data-tilt]');
      if (card && !card.contains(e.relatedTarget)) {
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      }
      var mag = e.target.closest && e.target.closest('[data-magnetic], .hero__cta .btn');
      if (mag && !mag.contains(e.relatedTarget)) mag.style.transform = '';
    }, { passive: true });
  }

  /* =======================================================
     SCROLL LOOP — progress, header, hero, parallax, words
     ======================================================= */
  var progress = document.querySelector('[data-progress]');
  var header = document.querySelector('.header');
  var hero = document.querySelector('[data-hero]');
  var heroFrame = hero && hero.querySelector('[data-hero-frame]');
  var heroCopy = hero && hero.querySelector('[data-hero-copy]');
  var parallax = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  var totop = document.querySelector('[data-totop]');
  var lastY = window.scrollY;
  var ticking = false;

  function frame() {
    ticking = false;
    var y = window.scrollY;
    var vh = window.innerHeight;
    var max = document.documentElement.scrollHeight - vh;

    if (progress) progress.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
    if (totop) totop.classList.toggle('is-visible', y > vh * 1.2);

    if (header) {
      var menuOpen = document.body.classList.contains('no-scroll');
      if (!menuOpen) {
        if (y > lastY + 6 && y > vh * 0.6) header.classList.add('is-hidden');
        else if (y < lastY - 6 || y < 80) header.classList.remove('is-hidden');
      }
      /* lets other sticky bars (PDP tabs) dock to the header's real edge */
      document.documentElement.classList.toggle('hdr-hidden', header.classList.contains('is-hidden'));
    }
    lastY = y;

    if (reduceMotion) return;

    if (heroFrame) {
      var h = hero.offsetHeight || vh;
      var p = Math.min(1, Math.max(0, y / h));
      heroFrame.style.transform = 'scale(' + (1 - p * 0.06).toFixed(4) + ')';
      if (heroCopy) {
        heroCopy.style.opacity = Math.max(0, 1 - p * 1.6).toFixed(3);
        heroCopy.style.transform = 'translate3d(0,' + (-p * 70).toFixed(1) + 'px,0)';
      }
    }

    parallax.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < -100 || box.top > vh + 100) return;
      var f = parseFloat(el.getAttribute('data-parallax')) || 0.15;
      var center = box.top + box.height / 2 - vh / 2;
      var limit = box.height * 0.1;
      var off = Math.max(-limit, Math.min(limit, -center * f));
      el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });

    statements.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      var start = vh * 0.88;
      var span = r.height + vh * 0.35;
      var p2 = Math.min(1, Math.max(0, (start - r.top) / span));
      var lit = Math.round(p2 * s.words.length);
      for (var i = 0; i < s.words.length; i++) s.words[i].classList.toggle('is-lit', i < lit);
    });
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  frame();

  if (totop) totop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();

/* =========================================================
   V5 — product page: gallery counter, recs, tabs
   ========================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.querySelector('[data-wpdp]');
  if (!root) return;

  /* gallery: counter + keep the active thumb in view */
  var gallery = root.querySelector('[data-gallery]');
  if (gallery) {
    var vp = gallery.querySelector('[data-carousel-viewport]');
    var counter = gallery.querySelector('[data-gallery-index]');
    var rail = gallery.querySelector('.wpdp__thumbs');
    var raf;
    if (vp) vp.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = Math.round(vp.scrollLeft / (vp.clientWidth || 1));
        if (counter) counter.textContent = idx + 1;
        var active = rail && rail.children[idx];
        if (active && rail.scrollHeight > rail.clientHeight + 2) {
          var top = active.offsetTop - rail.clientHeight / 2 + active.clientHeight / 2;
          rail.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        } else if (active && rail.scrollWidth > rail.clientWidth + 2) {
          var left = active.offsetLeft - rail.clientWidth / 2 + active.clientWidth / 2;
          rail.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
    }, { passive: true });
  }

  /* "others also bought": variant select drives the + button and price */
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-rec-select]');
    if (!sel) return;
    var card = sel.closest('.wrec');
    var opt = sel.options[sel.selectedIndex];
    var btn = card.querySelector('[data-quick-add]');
    if (btn) btn.setAttribute('data-quick-add', sel.value);
    var price = card.querySelector('[data-rec-price]');
    if (price && opt) {
      var compare = opt.getAttribute('data-compare');
      price.innerHTML = (compare ? '<s>' + compare + '</s>' : '') + '<b>' + opt.getAttribute('data-price') + '</b>';
    }
  });

  /* swap the collection fallback for Shopify's related recommendations */
  var recs = root.querySelector('[data-recs]');
  var recRoute = window.AC && window.AC.routes && window.AC.routes.productRecs;
  if (recs && recRoute) {
    var url = recRoute + '?section_id=product-recs&intent=related' +
      '&product_id=' + encodeURIComponent(recs.getAttribute('data-product-id')) +
      '&limit=' + encodeURIComponent(recs.getAttribute('data-limit') || '2');
    fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var result = doc.querySelector('[data-recs-result]');
      if (result && result.querySelector('.wrec')) {
        recs.querySelector('[data-recs-list]').innerHTML = result.innerHTML;
      }
    }).catch(function () {});
  }

  /* segmented tabs: smooth-jump, open the target card, scroll-spy */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-wtab]'));
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = document.querySelector(tab.getAttribute('href'));
      if (target && target.tagName === 'DETAILS') target.open = true;
      tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
    });
  });
  if ('IntersectionObserver' in window && tabs.length) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = '#' + entry.target.id;
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('href') === id); });
      });
    }, { rootMargin: '-35% 0px -55% 0px' });
    tabs.forEach(function (t) {
      var target = document.querySelector(t.getAttribute('href'));
      if (target) spy.observe(target);
    });
  }
})();

/* =========================================================
   V6 — announcement bar + live header measurements
   ========================================================= */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var header = document.querySelector('.header');
  var ann = document.querySelector('[data-ann]');

  /* --header-h  : live height (sticky bars dock to it)
     --header-h0 : height with the bar expanded (stable page offset)
     --ann-h     : the bar's full height                               */
  function measure() {
    if (!header) return;
    var annFull = ann ? ann.scrollHeight : 0;
    var annNow = ann ? ann.offsetHeight : 0;
    docEl.style.setProperty('--ann-h', annFull + 'px');
    docEl.style.setProperty('--header-h0', (header.offsetHeight - annNow + annFull) + 'px');
    docEl.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  measure();
  if ('ResizeObserver' in window && header) new ResizeObserver(measure).observe(header);
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);

  if (!ann) return;

  var msgs = Array.prototype.slice.call(ann.querySelectorAll('[data-ann-msg]'));
  var idx = 0;
  var timer = null;
  var paused = false;
  var speed = (parseInt(ann.getAttribute('data-ann-speed'), 10) || 4) * 1000;

  function show(next) {
    if (!msgs.length || next === idx) return;
    next = (next + msgs.length) % msgs.length;
    var leaving = msgs[idx];
    leaving.classList.remove('is-active');
    leaving.classList.add('is-leaving');
    setTimeout(function () { leaving.classList.remove('is-leaving'); }, 650);
    msgs[next].classList.add('is-active');
    idx = next;
  }

  function start() {
    stop();
    if (msgs.length < 2 || reduceMotion) return;
    timer = setInterval(function () { if (!paused && !document.hidden) show(idx + 1); }, speed);
  }
  function stop() { if (timer) clearInterval(timer); timer = null; }

  var prev = ann.querySelector('[data-ann-prev]');
  var next = ann.querySelector('[data-ann-next]');
  if (prev) prev.addEventListener('click', function () { show(idx - 1); start(); });
  if (next) next.addEventListener('click', function () { show(idx + 1); start(); });

  ann.addEventListener('mouseenter', function () { paused = true; });
  ann.addEventListener('mouseleave', function () { paused = false; });
  ann.addEventListener('focusin', function () { paused = true; });
  ann.addEventListener('focusout', function () { paused = false; });

  /* theme editor: selecting a block shows it and holds it */
  document.addEventListener('shopify:block:select', function (e) {
    var i = msgs.indexOf(e.target);
    if (i > -1) { stop(); show(i); }
  });
  document.addEventListener('shopify:block:deselect', start);

  start();
})();

/* =========================================================
   V7 — PDP quantity limits + reviews card
   ========================================================= */
(function () {
  'use strict';

  /* keep typed/stepped quantities inside 1..99 */
  document.querySelectorAll('[data-qty-input]').forEach(function (input) {
    function clamp() {
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 99;
      var v = parseInt(input.value, 10);
      input.value = isNaN(v) ? min : Math.min(max, Math.max(min, v));
    }
    input.addEventListener('change', clamp);
    input.addEventListener('blur', clamp);
  });

  /* reviews: write-a-review toggle, show more */
  document.querySelectorAll('[data-review-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    function open(state) {
      panel.hidden = !state;
      btn.setAttribute('aria-expanded', state ? 'true' : 'false');
      btn.textContent = state ? 'Close' : 'Write a review';
      if (state) {
        var first = panel.querySelector('input:not([type=hidden]):not([type=radio]), textarea');
        if (first) first.focus({ preventScroll: true });
      }
    }
    btn.addEventListener('click', function () { open(panel.hidden); });
    /* after submitting, Shopify reloads the page: show the result */
    if (panel.querySelector('[data-review-posted], .notice--err')) {
      open(true);
      panel.scrollIntoView({ block: 'center' });
    }
  });

  document.querySelectorAll('[data-review-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var list = btn.closest('.wreviews').querySelector('[data-review-list]');
      if (list) list.querySelectorAll('.is-more').forEach(function (el) { el.classList.remove('is-more'); });
      btn.parentElement.remove();
    });
  });
})();
